import { render, staticRenderFns } from "./OverviewSlides.vue?vue&type=template&id=ad56af0c&scoped=true"
import script from "./OverviewSlides.vue?vue&type=script&lang=ts"
export * from "./OverviewSlides.vue?vue&type=script&lang=ts"
import style0 from "./OverviewSlides.vue?vue&type=style&index=0&id=ad56af0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad56af0c",
  null
  
)

export default component.exports